var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransactionReportNonIdeal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 166,
    viewBox: "0 0 153 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13643_28347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.6244 86.1877H53.7811C54.4625 81.5554 55.0586 77.348 55.1438 75.7756C55.3567 72.5032 54.2496 69.6982 53.696 68.5508H42.667C42.1135 69.6982 41.0063 72.5032 41.2192 75.7756C41.3895 77.348 41.9431 81.5129 42.6244 86.1877Z",
    fill: "#B0C9E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.27 58.4355H123.788V86.0597H144.27V58.4355Z",
    fill: "#485667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.184 58.4355H121.701V86.0597H142.184V58.4355Z",
    fill: "#4F5E71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.073 55.6309H116.591V86.0599H137.073V55.6309Z",
    fill: "#727E8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.944 55.6309H111.48V86.0599H134.944V55.6309Z",
    fill: "#8993A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.943 55.6309H130.94V86.0599H134.943V55.6309Z",
    fill: "#727E8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7562 63.2383C17.7562 63.2383 14.5625 64.8532 13.1573 69.4431C11.752 74.033 19.3744 86.4851 19.3744 85.8476C19.3744 85.2526 26.9967 81.8527 26.9967 81.8527L23.1642 67.8281L17.7562 63.2383Z",
    fill: "#B0C9E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9399 87.5473L93.7242 76.3701H83.1211L87.3368 87.5473",
    fill: "#8993A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4873 78.5801H119.742L120.807 72.9277H60.5519",
    fill: "#C8CDD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8746 44.411L60.5518 72.9701H120.806L126.002 45.0909C126.214 43.986 125.363 42.966 124.213 42.966H67.6631C66.7688 42.9235 66.0449 43.5185 65.8746 44.411Z",
    fill: "#4F5E71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5547 83.5104L111.523 71.6532L95.8528 70.7607L81.1191 82.1504L95.5547 83.5104Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0841 79.6852L95.0869 77.4753C95.0869 77.4753 98.962 75.8604 99.0897 75.8604C99.2175 75.8604 99.5581 76.2428 99.1323 77.0078C98.7065 77.7728 97.6419 77.9853 97.6419 77.9853L96.918 79.9827L100.623 79.4727L101.474 79.2602C101.474 79.2602 100.878 80.7477 100.623 81.1302C100.367 81.4702 98.962 82.3627 98.962 82.3627C98.962 82.3627 96.3218 84.5726 95.3424 84.8276C94.363 85.0826 91.0841 85.2101 91.0841 85.2101L88.9976 85.1676L87.0388 85.5501C87.0388 85.5501 86.0168 83.6801 86.1871 81.0877L91.0841 79.6852Z",
    fill: "#FF8D68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.887 88.8649L126.512 164.598H129.322L121.7 88.4824L114.887 88.8649Z",
    fill: "#C8CDD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.562 88.8649L150.188 164.598H152.998L145.376 88.4824L138.562 88.8649Z",
    fill: "#C8CDD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3028 88.8649L58.6777 164.598H55.8672L63.4895 88.4824L70.3028 88.8649Z",
    fill: "#C2D3EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.627 88.8649L35.0019 164.598H32.1914L39.8137 88.4824L46.627 88.8649Z",
    fill: "#C2D3EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.995 88.0576H42.2412V91.67H146.995V88.0576Z",
    fill: "#B0C9E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.996 89.6726H45.435C44.3278 89.6726 43.4336 88.7801 43.4336 87.6752C43.4336 86.5702 44.3278 85.6777 45.435 85.6777H148.996C150.104 85.6777 150.998 86.5702 150.998 87.6752C150.998 88.7801 150.104 89.6726 148.996 89.6726Z",
    fill: "#485667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8848 156.991C48.8848 156.991 49.5235 155.376 52.2914 155.673C55.0593 155.971 55.3999 156.481 55.7832 157.798C56.1664 159.158 57.1884 160.561 57.8272 160.858C58.4659 161.156 60.8505 162.601 62.7668 162.813C64.683 163.026 64.9385 164.173 64.5553 164.726C64.172 165.278 57.0181 166.043 55.4425 165.915C55.4425 165.915 50.0771 166.085 48.7996 165.703C47.5221 165.363 48.8422 157.501 48.8848 156.991Z",
    fill: "#4F5E71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6509 145.431L48.8418 157.968C48.8418 157.968 50.8006 158.605 52.291 159.71C54.5053 161.325 56.2938 159.37 56.2938 159.37L56.8048 151.465L49.6509 145.431Z",
    fill: "#FF8D68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6191 123.331L57.4858 158.18C57.4858 158.18 53.2701 158.775 48.1602 156.395C48.1602 156.395 52.6739 123.629 52.972 121.546C53.2701 119.421 65.0229 121.504 65.6191 123.331Z",
    fill: "#B0C9E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6599 33.1495C32.6599 33.1495 35.9814 33.787 38.1957 38.6743C40.41 43.5617 39.8564 54.3563 38.7067 55.6738C37.557 57.0338 33.7671 56.7788 28.4017 55.4188C22.7807 53.9739 20.5239 48.364 19.2889 44.6666C16.9469 37.5693 22.7382 29.7071 32.6599 33.1495Z",
    fill: "#FF8D68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.377 61.8786L25.2932 52.6988C25.2932 52.6988 30.2328 50.9139 33.5968 54.0588L34.7466 55.4613L35.1298 61.3261C35.1724 61.2836 29.9773 62.686 23.377 61.8786Z",
    fill: "#FF8D68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2918 118.275C23.2918 118.275 34.0652 121.42 46.7975 120.995C59.5723 120.57 61.2331 116.957 61.6589 113.515C62.0421 110.073 52.1203 107.99 47.8195 106.843C43.5186 105.695 28.7424 101.488 24.7396 105.78C20.7368 110.073 19.8 115.342 23.2918 118.275Z",
    fill: "#4F5E71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6918 156.991C78.6918 156.991 79.3306 155.376 82.0984 155.673C84.8663 155.971 85.207 156.481 85.5902 157.798C85.9735 159.158 86.9955 160.561 87.6342 160.858C88.273 161.156 90.6576 162.601 92.5738 162.813C94.49 163.026 94.7455 164.173 94.3623 164.726C93.9791 165.278 86.8251 166.043 85.2496 165.915C85.2496 165.915 79.8841 166.085 78.6067 165.703C77.3292 165.363 78.6067 157.501 78.6918 156.991Z",
    fill: "#4F5E71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.541 146.366L78.5644 158.563C78.5644 158.563 80.9916 157.968 82.3968 159.158C83.8021 160.348 86.3996 159.541 86.3996 159.541L84.1853 149.936L75.541 146.366Z",
    fill: "#FF8D68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6728 105.482C51.269 105.482 71.7513 112.282 75.7541 115.3C79.7569 118.487 86.1869 154.186 86.5701 154.993C86.9534 155.801 80.7363 158.011 76.7335 157.416C76.5206 156.608 67.1098 126.519 67.1098 124.522C67.1098 124.522 51.0561 123.714 44.2428 122.524C37.4296 121.334 32.7881 121.122 29.9776 113.727C27.1671 106.332 43.6041 105.695 43.6041 105.695L50.6728 105.482Z",
    fill: "#B0C9E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6758 79.176C85.6758 79.176 89.5934 79.091 89.8915 79.4735C90.1896 79.856 91.5948 83.4684 90.2747 84.9983C89.1676 85.8058 89.1676 85.8058 89.1676 85.8058H85.7609L85.6758 79.176Z",
    fill: "#E2E7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6963 60.5189L23.7609 57.799C23.7609 57.799 30.0631 55.8441 35.5137 58.2665C36.8764 59.6265 37.6003 61.7089 37.6003 61.7089L22.6963 60.5189Z",
    fill: "#E2E7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 60.8584C21.3333 60.8584 22.1423 59.4559 23.5476 59.2434C24.9528 59.0309 31.3828 58.2234 35.5985 59.4559C37.2166 60.0509 38.0257 60.8584 38.0257 60.8584C38.0257 60.8584 44.0299 62.8558 46.0739 64.0458C48.0753 65.2357 48.6714 74.458 49.0972 77.4754C49.4805 80.4928 48.2882 83.6802 48.2882 83.6802C48.2882 83.6802 53.1 103.315 53.1 106.119C53.1 108.924 51.4819 112.112 45.8609 114.152C40.24 116.149 24.9954 115.342 19.7577 112.154C18.1395 108.967 15.7549 70.8881 15.3291 67.2757C14.9458 63.6208 21.3333 60.8584 21.3333 60.8584Z",
    fill: "#B0C9E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7101 63.2381C42.7101 63.2381 44.2005 62.3457 47.8201 64.7256C51.4396 67.148 61.3614 76.1578 62.5537 76.7527C63.746 77.3477 86.9536 78.5377 86.9536 78.5377C86.9536 78.5377 90.2751 82.7451 86.6556 86.06C86.6556 86.06 64.2996 86.9524 60.0839 86.6549C55.8682 86.3574 41.8159 78.2402 41.8159 78.2402C41.8159 78.2402 36.1098 69.8679 42.7101 63.2381Z",
    fill: "#B0C9E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8975 76.498C37.8975 76.498 56.6765 86.3152 58.8482 86.6552C61.0199 86.9527 69.3236 86.6552 69.3236 86.6552",
    stroke: "#1B2048",
    strokeWidth: 0.8263,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2347 79.0059C63.2347 79.0059 63.8735 82.4483 61.6592 84.4882",
    stroke: "#1B2048",
    strokeWidth: 0.8263,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6396 78.0703C64.6396 78.0703 66.5133 81.0452 65.5765 83.2127",
    stroke: "#1B2048",
    strokeWidth: 0.8263,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7269 72.5884C37.7269 72.5884 36.1514 67.106 41.6446 63.5361",
    stroke: "#1B2048",
    strokeWidth: 0.8263,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5857 67.4453C17.5857 67.4453 16.4785 77.135 16.4785 81.6399",
    stroke: "#1B2048",
    strokeWidth: 0.8263,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.207 61.0284C23.207 61.0284 30.4035 60.391 36.3225 61.0284",
    stroke: "#1B2048",
    strokeWidth: 0.8263,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2607 123.926C70.2607 123.926 73.7099 122.821 74.9449 117.509",
    stroke: "#1B2048",
    strokeWidth: 0.8263,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6025 124.394C72.6025 124.394 74.6465 123.756 75.5833 120.951",
    stroke: "#1B2048",
    strokeWidth: 0.8263,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1258 130.514L54.9307 156.268",
    stroke: "#1B2048",
    strokeWidth: 0.8263,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4722 39.6516C37.4722 39.6516 38.0684 42.3715 35.6837 44.1564L35.8541 47.1738C35.8541 47.1738 36.7483 49.8938 36.1521 50.1912C35.556 50.4887 35.3856 50.0213 35.3856 50.0213C35.3856 50.0213 33.4268 46.8763 32.8307 46.7064C32.2345 46.5364 34.1933 50.9137 34.1933 50.9137C34.1933 50.9137 32.2345 53.9311 28.615 54.3561L29.3815 53.2937C29.3815 53.2937 27.7207 54.3561 25.1658 54.1861C22.6108 54.0161 20.652 50.1488 20.652 50.1488C20.652 50.1488 21.1204 51.2112 20.652 51.6362C20.1836 52.1037 17.6286 48.1938 17.5009 43.2215L16.7344 44.7089C16.7344 44.7089 16.9047 41.2665 18.2248 37.3566C19.5874 33.4468 25.5916 30.5993 28.9131 30.5993C32.2345 30.5993 35.556 30.8968 36.4502 30.5993C37.3444 30.3018 36.9186 32.8518 36.9186 32.8518C36.9186 32.8518 37.387 31.7893 37.5148 30.8968C38.1109 30.4293 39.0052 34.0417 38.7071 35.4017C38.409 36.7617 38.409 36.7617 38.409 36.7617C38.409 36.7617 39.4736 35.4017 39.6013 34.6792C40.1549 34.5517 40.0272 37.8666 37.4722 39.6516Z",
    fill: "#4F5E71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2581 47.1311C35.2581 47.1311 34.6619 45.1337 33.0012 46.1961C31.3405 47.2586 33.6825 51.976 35.0878 51.5935C36.493 51.1685 35.6413 47.8961 35.2581 47.1311Z",
    fill: "#8993A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3643 81.9797L100.623 81.1297L101.474 79.2598",
    stroke: "#C8CDD3",
    strokeWidth: 1.2805,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.452 81.2148C100.452 81.2148 98.2801 82.9998 97.982 83.1698C97.6839 83.3398 96.3213 83.6798 96.3213 83.6798",
    stroke: "#C8CDD3",
    strokeWidth: 1.2805,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6186 52.2314C34.6186 52.2314 34.0225 54.3139 37.642 55.5463",
    stroke: "#C8CDD3",
    strokeWidth: 1.2805,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.889 68.0402H84.7812L88.784 47.2158H120.891L116.889 68.0402Z",
    fill: "#727E8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4342 54.4414C74.3065 55.0364 74.7749 55.5889 75.3711 55.5889H110.332C110.8 55.5889 111.183 55.2489 111.268 54.8239L111.779 52.1465H74.8601L74.4342 54.4414Z",
    fill: "#B0C9E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.59 31.6191H79.629C79.1606 31.6191 78.7774 31.9591 78.6922 32.3841L74.9023 52.1035H111.822L115.569 32.7666C115.654 32.1716 115.228 31.6191 114.59 31.6191Z",
    fill: "#CAE5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7003 55.5882C91.1687 54.3132 91.4242 53.4207 91.4242 53.4207C91.4242 53.4207 92.4888 47.9384 87.7621 49.3409C87.7621 49.3409 86.1439 50.5733 85.3774 53.1233C85.1219 53.9307 84.8664 54.7807 84.5684 55.5882H90.7003Z",
    fill: "#B0C9E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.452 55.5886C100.367 52.8687 100.196 50.7013 99.8983 50.1063C99.0467 48.5338 95.5123 47.0889 95.5123 47.0889L90.7004 47.8113C90.7004 47.8113 88.699 48.4063 88.0603 49.8088C87.8474 50.2763 87.3364 52.6562 86.7402 55.5886H100.452Z",
    fill: "#DCE4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5095 43.8585C91.5095 43.8585 91.2114 46.0259 90.5727 47.5984C90.5727 47.5984 90.4023 48.8308 92.9573 48.2783C95.5123 47.7684 95.1716 46.4934 95.1716 46.4934V41.3936L91.5095 43.8585Z",
    fill: "#FF8D68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8898 38.5467C87.8898 38.5467 87.9324 43.3491 89.2951 45.6865C90.2319 46.664 93.4682 45.134 94.7883 43.0516C96.1509 40.9692 96.1083 37.8667 95.0437 36.1243C93.9792 34.3818 90.4448 34.9343 89.4228 35.5293C88.4434 36.1243 87.8473 37.7817 87.8898 38.5467Z",
    fill: "#FF8D68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4049 41.2664C94.4049 41.2664 95.2992 39.864 95.9379 40.7139C96.5341 41.5639 94.4475 43.2639 94.2772 42.5839C94.1068 41.9464 94.4049 41.2664 94.4049 41.2664Z",
    fill: "#FBA894"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.89 38.5466C87.89 38.5466 86.1867 37.0591 88.2306 35.1467C89.3804 34.2542 89.9765 34.9342 91.2114 34.6792C92.4463 34.4667 94.6606 34.6792 95.4697 35.9542C96.2788 37.2291 95.9807 40.204 95.7678 40.5015C95.5549 40.799 94.831 40.969 94.831 41.479C94.831 41.989 94.7032 42.414 94.5329 42.414C94.3626 42.414 94.3626 41.5215 94.3626 40.884C94.3626 40.2465 94.2348 39.0141 93.9367 38.1641C93.6386 37.2716 92.3186 37.3566 91.765 37.4841C91.2966 37.5691 90.9559 38.9291 87.89 38.5466Z",
    fill: "#2B343E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M94.2344 39.9917C94.2344 39.9917 94.277 39.9917 94.3195 39.9492L94.2344 39.9917Z",
    fill: "#505E83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.3626 39.9491C94.3626 40.0341 94.6607 42.839 93.5535 43.604C92.4038 44.369 92.3612 43.3915 91.4244 43.264C90.5302 43.1365 89.7637 43.179 89.3804 43.774C89.0398 44.369 89.0823 44.624 88.7417 44.454C88.6565 44.6665 89.1675 45.8139 89.934 46.1114C90.7005 46.4089 92.5315 45.474 93.3406 44.7515C94.1497 44.029 94.6607 43.5615 94.7884 42.9665C94.9162 42.329 94.8736 41.1391 95.0439 40.3316C95.1717 39.6516 94.5755 39.8216 94.3626 39.9491ZM90.1469 45.0915C89.0398 44.8365 89.1675 43.9865 90.3172 43.6465C90.3172 43.6465 91.5096 43.094 91.9354 43.944C92.1057 44.454 91.2541 45.304 90.1469 45.0915Z",
    fill: "#2B343E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1711 46.1113C95.1711 46.1113 93.7659 47.8538 91.4664 48.0663C90.998 47.8963 90.7425 47.0463 90.7425 47.0463L90.4019 47.5988C90.4019 47.5988 90.2315 48.6613 90.4019 49.0862C90.6148 49.1287 91.4239 48.5763 91.4239 48.5763C91.4239 48.5763 91.9774 49.3412 92.3607 49.4687C92.7439 49.5962 95.2563 47.9388 95.5118 47.0888C95.5118 47.0888 95.4692 46.5363 95.1711 46.1113Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.792 55.5886C100.665 52.9112 100.494 50.8713 100.367 50.4463C99.7704 49.0863 97.6412 47.3864 95.5121 47.0889C95.5121 47.0889 94.703 50.7863 93.9365 55.5886H100.792Z",
    fill: "#B0C9E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4012 55.5887C89.551 50.7864 90.4026 47.9814 90.4026 47.9814C89.7639 48.0664 88.6142 48.5764 87.8051 49.3414C87.3792 50.1914 86.6979 52.6563 86.0166 55.5887H88.4012Z",
    fill: "#B0C9E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.367 55.5887C100.452 53.0388 100.282 50.6589 99.8984 50.1064C98.5357 48.9589 97.0879 49.0439 96.364 50.3189C95.9808 51.0413 95.4698 53.5063 95.0439 55.5887H100.367Z",
    fill: "#B0C9E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.382 48.5762C90.9561 50.2336 90.6155 51.8911 90.3174 53.591",
    stroke: "#87B8EB",
    strokeWidth: 0.3595,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.791 35.4218C121.176 32.4389 122.027 27.8814 119.692 25.2423C117.357 22.6032 112.72 22.8818 109.336 25.8647C105.951 28.8475 105.1 33.4051 107.435 36.0442C109.77 38.6833 114.407 38.4046 117.791 35.4218Z",
    fill: "#6787FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.693 34.2967C111.48 34.2967 111.267 34.2117 111.14 34.0417L109.266 31.5768C109.01 31.2368 109.138 30.6843 109.564 30.3018C109.99 29.9618 110.543 29.9618 110.841 30.3018L112.247 32.1717L117.229 28.1769C117.655 27.8369 118.208 27.8369 118.506 28.1769C118.762 28.5169 118.634 29.0693 118.208 29.4518L112.417 34.0842C112.161 34.2117 111.906 34.2967 111.693 34.2967Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M132.006 69.4427H103.475C103.177 69.4427 102.964 69.1453 103.049 68.8903L105.732 58.6906C105.774 58.4781 105.987 58.3506 106.158 58.3506H134.688C134.986 58.3506 135.199 58.6481 135.114 58.9031L132.431 69.1028C132.431 69.3153 132.218 69.4427 132.006 69.4427Z",
    fill: "#BFD9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.393 60.5176H117.314",
    stroke: "#A9C2FF",
    strokeWidth: 1.076,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.626 65.1074H116.548",
    stroke: "#A9C2FF",
    strokeWidth: 1.076,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.799 63.3652H120.721",
    stroke: "#A9C2FF",
    strokeWidth: 1.076,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.137 62.0479H110.118",
    stroke: "#A9C2FF",
    strokeWidth: 1.076,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.754 63.3652H109.735",
    stroke: "#A9C2FF",
    strokeWidth: 1.076,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.89 60.5176H122.467",
    stroke: "#A9C2FF",
    strokeWidth: 1.076,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.635 67.2324H115.355C115.313 67.2324 115.312 67.1899 115.312 67.1899L115.568 66.2974C115.568 66.2974 115.568 66.2549 115.611 66.2549H120.891C120.933 66.2549 120.933 66.2974 120.933 66.2974L120.635 67.2324ZM120.635 67.2324C120.678 67.2324 120.678 67.2324 120.635 67.2324Z",
    stroke: "#84AEE5",
    strokeWidth: 0.3587,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.078 67.2324H108.797C108.755 67.2324 108.755 67.1899 108.755 67.1899L109.01 66.2974C109.01 66.2974 109.01 66.2549 109.053 66.2549H114.333C114.376 66.2549 114.376 66.2974 114.376 66.2974L114.078 67.2324Z",
    stroke: "#84AEE5",
    strokeWidth: 0.3587,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.919 65.9155C129.664 65.5755 128.557 65.278 128.259 64.938C128.088 64.768 128.088 64.428 128.131 64.1305C128.259 64.0456 128.344 64.0031 128.386 63.9181C128.472 63.7906 128.599 63.5781 128.684 63.4081C128.727 63.4506 128.77 63.4506 128.812 63.4506C128.94 63.4506 129.493 62.6856 129.366 62.5156C129.281 62.4306 129.153 62.5156 129.068 62.6006C129.195 62.2606 129.323 62.0056 129.323 62.0056C129.323 61.9631 129.366 61.9206 129.366 61.8781C129.579 60.9856 129.068 60.3057 128.173 60.3057C127.279 60.3057 126.428 61.0281 126.215 61.8781C126.215 61.9206 126.215 61.9631 126.172 62.0056C126.172 62.0056 126.129 62.2606 126.129 62.6006C126.087 62.5156 126.002 62.4306 125.874 62.5156C125.661 62.6856 125.831 63.4506 125.959 63.4506C126.002 63.4506 126.044 63.4081 126.129 63.4081C126.129 63.6206 126.129 63.7906 126.172 63.9181C126.215 64.0031 126.257 64.0881 126.385 64.1731C126.257 64.4705 126.129 64.768 125.874 64.938C125.406 65.278 124.171 65.5755 123.702 65.9155C123.276 66.2555 122.936 67.1905 122.851 67.3605H130.09C130.047 67.1905 130.175 66.2555 129.919 65.9155Z",
    fill: "#B0C9E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3407 65.8303H69.9202C67.8762 65.8303 66.5988 64.1729 67.1097 62.1329C67.6207 60.093 69.7073 58.4355 71.7513 58.4355H95.1718C97.2158 58.4355 98.4933 60.093 97.9823 62.1329C97.4713 64.1729 95.3847 65.8303 93.3407 65.8303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3901 63.0683L71.3681 63.5358C71.283 63.5783 71.1978 63.4933 71.2404 63.4083L71.6662 62.4308C71.6662 62.3883 71.6662 62.3458 71.6662 62.3458L71.1126 61.6659C71.0701 61.5809 71.1126 61.4959 71.2404 61.4534L72.2624 61.3259C72.305 61.3259 72.3475 61.2834 72.3475 61.2834L73.0289 60.3909C73.0715 60.3059 73.1992 60.3059 73.2418 60.3909L73.4547 61.2834C73.4547 61.3259 73.4973 61.3259 73.5399 61.3259L74.4767 61.4534C74.5619 61.4534 74.5619 61.5809 74.4767 61.6659L73.5825 62.3458C73.5399 62.3883 73.5399 62.3883 73.5399 62.4308L73.4547 63.4083C73.4547 63.4933 73.327 63.5783 73.2418 63.5358L72.4753 63.0683C72.4753 63.0683 72.4327 63.0683 72.3901 63.0683Z",
    fill: "#FFA402"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3726 63.0683L76.3506 63.5358C76.2654 63.5783 76.1802 63.4933 76.2228 63.4083L76.6486 62.4308C76.6486 62.3883 76.6486 62.3458 76.6486 62.3458L76.0951 61.6659C76.0525 61.5809 76.0951 61.4959 76.2228 61.4534L77.2448 61.3259C77.2874 61.3259 77.33 61.2834 77.33 61.2834L78.0113 60.3909C78.0539 60.3059 78.1816 60.3059 78.2242 60.3909L78.4371 61.2834C78.4371 61.3259 78.4797 61.3259 78.5223 61.3259L79.4591 61.4534C79.5443 61.4534 79.5443 61.5809 79.4591 61.6659L78.5649 62.3458C78.5223 62.3883 78.5223 62.3883 78.5223 62.4308L78.4371 63.4083C78.4371 63.4933 78.3094 63.5783 78.2242 63.5358L77.4577 63.0683C77.4151 63.0683 77.3726 63.0683 77.3726 63.0683Z",
    fill: "#FFA402"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.312 63.0683L81.29 63.5358C81.2049 63.5783 81.1197 63.4933 81.1623 63.4083L81.5881 62.4308C81.5881 62.3883 81.5881 62.3458 81.5881 62.3458L81.0345 61.6659C80.9919 61.5809 81.0345 61.4959 81.1623 61.4534L82.1843 61.3259C82.2268 61.3259 82.2694 61.2834 82.2694 61.2834L82.9507 60.3909C82.9933 60.3059 83.1211 60.3059 83.1637 60.3909L83.3766 61.2834C83.3766 61.3259 83.4192 61.3259 83.4617 61.3259L84.3986 61.4534C84.4837 61.4534 84.4837 61.5809 84.3986 61.6659L83.5043 62.3458C83.4617 62.3883 83.4617 62.3883 83.4617 62.4308L83.3766 63.4083C83.3766 63.4933 83.2488 63.5783 83.1637 63.5358L82.3972 63.0683C82.3546 63.0683 82.312 63.0683 82.312 63.0683Z",
    fill: "#FFA402"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2515 63.0683L86.2295 63.5358C86.1443 63.5783 86.0591 63.4933 86.1017 63.4083L86.5276 62.4308C86.5276 62.3883 86.5276 62.3458 86.5276 62.3458L85.974 61.6659C85.9314 61.5809 85.974 61.4959 86.1017 61.4534L87.1237 61.3259C87.1663 61.3259 87.2089 61.2834 87.2089 61.2834L87.8902 60.3909C87.9328 60.3059 88.0605 60.3059 88.1031 60.3909L88.316 61.2834C88.316 61.3259 88.3586 61.3259 88.4012 61.3259L89.338 61.4534C89.4232 61.4534 89.4232 61.5809 89.338 61.6659L88.4438 62.3458C88.4012 62.3883 88.4012 62.3883 88.4012 62.4308L88.316 63.4083C88.316 63.4933 88.1883 63.5783 88.1031 63.5358L87.3366 63.0683C87.294 63.0683 87.294 63.0683 87.2515 63.0683Z",
    fill: "#FFA402"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1909 63.0683L91.1689 63.5358C91.0838 63.5783 90.9986 63.4933 91.0412 63.4083L91.467 62.4308C91.467 62.3883 91.467 62.3458 91.467 62.3458L90.9134 61.6659C90.8708 61.5809 90.9134 61.4959 91.0412 61.4534L92.0632 61.3259C92.1057 61.3259 92.1483 61.2834 92.1483 61.2834L92.8297 60.3909C92.8722 60.3059 93 60.3059 93.0426 60.3909L93.2555 61.2834C93.2555 61.3259 93.2981 61.3259 93.3406 61.3259L94.2775 61.4534C94.3626 61.4534 94.3626 61.5809 94.2775 61.6659L93.3832 62.3458C93.3407 62.3883 93.3406 62.3883 93.3406 62.4308L93.2555 63.4083C93.2555 63.4933 93.1277 63.5783 93.0426 63.5358L92.2761 63.0683C92.2761 63.0683 92.2335 63.0683 92.1909 63.0683Z",
    fill: "#C2D4D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7688 51.4662C36.8271 51.4662 37.685 50.2674 37.685 48.7887C37.685 47.3101 36.8271 46.1113 35.7688 46.1113C34.7105 46.1113 33.8525 47.3101 33.8525 48.7887C33.8525 50.2674 34.7105 51.4662 35.7688 51.4662Z",
    fill: "#B0C9E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0664 49.0439C36.0664 49.0439 41.4744 54.9938 41.4744 55.9712C41.4744 56.9062 39.7285 56.7787 39.7285 56.7787",
    stroke: "#B0C9E5",
    strokeWidth: 1.1018,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1119 56.7361C40.1119 57.1186 39.8138 57.4586 39.388 57.4586C39.0047 57.4586 38.6641 57.1611 38.6641 56.7361C38.6641 56.3537 38.9621 56.0137 39.388 56.0137C39.8138 56.0562 40.1119 56.3537 40.1119 56.7361Z",
    fill: "#B0C9E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4863 126.646C28.4026 129.961 34.4067 132.341 41.5181 132.341C48.6294 132.341 54.6336 129.919 56.5498 126.646H26.4863Z",
    fill: "#8993A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1102 109.689L63.4907 126.349H61.2764L63.2778 110.114L67.1102 109.689Z",
    fill: "#C8CDD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7526 111.092H41.3896V107.097H70.5163C72.3048 107.097 73.71 108.542 73.71 110.284V111.092H73.7526Z",
    fill: "#727E8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.946 124.521L7.11079 86.9524C6.81271 85.465 7.96244 84.0625 9.45284 84.0625H35.3432C36.7484 84.0625 37.9833 85.0825 38.2814 86.4424L46.2018 124.521",
    fill: "#C8CDD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1322 128.644H18.9491C17.2883 128.644 15.8405 127.539 15.3721 125.966L14.9463 124.521H68.1322V128.644Z",
    fill: "#C8CDD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.945 130.556H40.0273V165.405H43.945V130.556Z",
    fill: "#C8CDD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.945 137.015L40.0273 140.16V130.556H43.945V137.015Z",
    fill: "#8993A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8174 160.178H42.3696H42.0289H40.5811L25.9326 166H58.4659L43.8174 160.178Z",
    fill: "#C8CDD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5596 86.6553H33.8524",
    stroke: "#8993A0",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2373 89.333L40.2401 109.307",
    stroke: "#8993A0",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9209 112.835L41.7726 118.657",
    stroke: "#8993A0",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1628 29.834H76.0529C73.6257 29.834 71.241 31.7889 70.73 34.2114C70.219 36.6338 71.752 38.5887 74.1792 38.5887H75.2864C76.5213 41.5211 79.4595 41.1386 79.4595 41.1386C78.9059 40.0337 78.7782 39.1412 78.7782 38.5887H79.2892C81.7164 38.5887 84.101 36.6338 84.612 34.2114C85.1656 31.7889 83.59 29.834 81.1628 29.834Z",
    fill: "#8993A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8809 33.3613H78.7353",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.498 35.2734H81.3333",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13643_28347"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 153,
    height: 166,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionReportNonIdeal);
export default __webpack_public_path__ + "static/media/transactionReportNonIdeal.cc47a9658c1cc9c963158cfc9a65b36e.svg";
export { ForwardRef as ReactComponent };